import axios from 'axios';
import BaseService from './base';

class LeadService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/lead`;
  }

  getCoordenates(param) {
    const address = `${param.city}+${param.state}+CEP:${param.zipcode.replace('.','')}+${param.country}`
    return this.request(`https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=AIzaSyC27IQyViFB4ip6CAfIXeZbnyohxdeVEEc`, null)
      .then(response => response.results)
      .catch(err => {
        throw err;
      });
  }

  getAddressByZipcode(formatted) {
    const cepClean = formatted.replace(/\D/g, '');
    return axios.get(`https://viacep.com.br/ws/${cepClean}/json`, null)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  save(model) {

    return this.request(`${this.getUrl()}`, model, 'POST')
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  send(leadId) {

    return this.request(`${this.getUrl()}/${leadId}/send`,)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }
}

export default new LeadService();